import React, { useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { Typography, Grid, Button, Menu, MenuItem, Box } from '@mui/material';
import Avatar from '@mui/material/Avatar';
import IconButton from '@mui/material/IconButton';
import VipFormerLogo from '../assets/images/logo.png';
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { isAdminUser } from '../utils/auth.js';
import CustomersList from './CustomersList';
import HomePage from './Homepage';

const Header = () => {
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = (event) => {
    setAnchorEl(null);
  };
  const signOut = () => {
    localStorage.clear();
    navigate('/signin');
  };
  return (
    <>
      <AppBar position="fixed" open={open} sx={{ backgroundColor: '#fff', zIndex: 99 }}>
        <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
          <Box className="cursor-hover">
            <Link
              to="/home"
              className="fastpass-issue"
            >
              <Box className="cursor-hover navLogo p-t-5">
                <img
                  className="logoImg-header vertical-inherit contrasts pl-35-r w-50"
                  src={VipFormerLogo}
                  alt="Logo"
                />
              </Box>
            </Link>
          </Box>
          <Grid className="d-flex">
            <IconButton>
              <Typography
                className="default-img-border justify-center align-center display-flex primary-btn-text bg-input f-16 font-weight-700 text-capitalize candidate-profile"
                width="42px"
                height="42px"
                aria-label="Default image"
              >
                {localStorage.getItem('username')
                  .trim()
                  .substring(0, 1)}
              </Typography>
            </IconButton>
            <Grid
              className="align-item-center "
            >
              <Box className="align-center display-flex" onClick={handleMenu}>
                <MenuIcon
                  className="gray9 f-25"
                  aria-label="Menu icon"
                />
              </Box>
              <Menu
                className={`navbar-responsive sidebar-dropdown`}
                id="menu-appbar"
                disableScrollLock={true}
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                Keepmounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
                open={open}
              >
                <Grid
                  container
                  item
                  lg={6}
                  md={6}
                  className="justify-end align-center navbar-responsive header-res"
                  sx={{ mt: 7 }}
                >
                  <Box>
                    <Box className="align-right">
                      <CloseIcon
                        className="f-25 font-weight-600 p-3px cursor-hover sub-text-color"
                        onClick={handleCloseMenu}
                        aria-label="Close icon"
                        tabIndex={0}
                        onKeyPress={handleCloseMenu}
                      />
                    </Box>
                    <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/customerList");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Customers
                      </Button>
                    </MenuItem>
                    <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/summary");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Inventory
                      </Button>
                    </MenuItem>
                    <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/amountHistory");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Amount Deposites
                      </Button>
                    </MenuItem>
                    {isAdminUser() ? <><MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/imports");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Imports
                      </Button>
                    </MenuItem>
                    <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/reports");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Analytics
                      </Button>
                    </MenuItem></> : ""}
                    <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/attendance");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Attendance
                      </Button>
                    </MenuItem>
                    {isAdminUser() ? <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/list-vendors");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Vendors
                      </Button>
                    </MenuItem> : ""}
                    {/* <MenuItem className="mt-10">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none"
                        onClick={() => {
                          navigate("/resetpassword");
                          handleCloseMenu();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        Reset Password
                      </Button>
                    </MenuItem> */}
                    <MenuItem className="mt-10 danger-color">
                      <Button
                        className="btn button-header gray9 f-16 font-weight-400 text-transform-none danger-color"
                        onClick={() => {
                          signOut();
                        }}
                        tabIndex={0}
                        disableRipple="true"
                        aria-label="button"
                        style={{ justifyContent: "left" }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth="1.5"
                          stroke="currentColor"
                          className="danger-color"
                          width="24px"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M15.75 9V5.25A2.25 2.25 0 0013.5 3h-6a2.25 2.25 0 00-2.25 2.25v13.5A2.25 2.25 0 007.5 21h6a2.25 2.25 0 002.25-2.25V15m3 0l3-3m0 0l-3-3m3 3H9"
                          />
                        </svg>
                        <span className="pl-10 p-t-2 danger-color">Logout</span>
                      </Button>
                    </MenuItem>
                  </Box>
                </Grid>
              </Menu>
            </Grid>
          </Grid>
        </Toolbar>
      </AppBar>
      <Box component="main" className='main-div-padding' sx={{ flexGrow: 1, width: '100%' }}>
        <HomePage />
      </Box>
    </>
  );
};

export default Header;
